
export default function MeritPathways() {
  return (
    <section className="py-28 px-6 lg:px-12 bg-gradient-to-br from-[#1A1F36] to-[#2D3748] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/4 right-[10%] w-96 h-96 bg-gradient-to-br from-[#7C4DFF]/20 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-[15%] w-96 h-96 bg-gradient-to-tr from-[#304FFE]/20 to-transparent rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            Turn your merit into opportunity
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            As you learn and earn microcredentials, you unlock Merit Pathways™, routes that give you access to merit scholarships and advantages based on your progress, not privilege.
          </p>
        </div>

        {/* Pathway visualization */}
        <div className="relative max-w-4xl mx-auto mb-12">
          <div className="flex items-center justify-between">
            {/* Start node */}
            <div className="flex flex-col items-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-[#304FFE] to-[#5B9FED] rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg">
                <i className="ri-flag-line text-3xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300 font-medium">Start</span>
            </div>

            {/* Connection line */}
            <div className="flex-1 h-1 bg-gradient-to-r from-[#304FFE] via-[#7C4DFF] to-[#FFA726] mx-4 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#304FFE] via-[#7C4DFF] to-[#FFA726] blur-sm"></div>
            </div>

            {/* Middle nodes */}
            <div className="flex flex-col items-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#7C4DFF] to-[#B794F6] rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300 font-medium">Badges</span>
            </div>

            <div className="flex-1 h-1 bg-gradient-to-r from-[#7C4DFF] to-[#FFA726] mx-4 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#7C4DFF] to-[#FFA726] blur-sm"></div>
            </div>

            <div className="flex flex-col items-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#B794F6] to-[#FF6B9D] rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg">
                <i className="ri-medal-line text-2xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300 font-medium">Credentials</span>
            </div>

            <div className="flex-1 h-1 bg-gradient-to-r from-[#FF6B9D] to-[#FFA726] mx-4 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-[#FF6B9D] to-[#FFA726] blur-sm"></div>
            </div>

            {/* End node */}
            <div className="flex flex-col items-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-[#FF6B9D] to-[#FFA726] rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform shadow-lg animate-pulse">
                <i className="ri-trophy-line text-3xl text-white"></i>
              </div>
              <span className="text-sm text-gray-300 font-medium">Opportunity</span>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button className="px-8 py-4 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white font-medium rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
            Unlock Your First Pathway
          </button>
        </div>
      </div>
    </section>
  );
}
